export const DRAWER_TYPES = {
  CASH: "CASH_DRAWER",
  EMPLOYEE_DRAWER: "EMPLOYEE_DRAWER",
};
